<template>
  <footer class="footer footer-big" data-background-color="black">
    <div class="container">
      <div class="content">
        <div class="row">
          <div class="col-md-3">
            <h5>Nosotros</h5>
            <ul class="links-vertical">
              <li>
                <a href="#/institucional" class="text-muted">Institucional</a>
              </li>
              <li>
                <a href="#/telefonos" class="text-muted">Teléfonos útiles</a>
              </li>
              <li>
                <a href="#/oficinas" class="text-muted">Oficinas</a>
              </li>
              <li>
                <a href="#/contacto" class="text-muted">Contacto</a>
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <h5 class="sssalud">SSSalud</h5>
            <div>
              <div class="feed-line">
                <p>
                  OSAPM RNOS: 1-1820-0 | RNEMP: 614173
                  SSSALUD 0800-222-72583
                  SSSalud - Organismo de control |<a href="https://www.argentina.gob.ar/sssalud" target="_blank">www.argentina.gob.ar/sssalud</a>
                  Avellaneda 2144 (C1406FYT)
                  Ciudad Autónoma de Buenos Aires
                  (54-11) 4633-7878
                </p>
              </div>
            </div>
          </div>
           <div class="col-md-3">
            <h5>Si sos víctima de violencia de género</h5>
                <div class="feed-line">
                <p>
                  Llamá al *144 . Las 24hs los 365 días del año
                </p>
              </div>

          </div>
          <!--
          <div class="col-md-3">
            <h5>Redes Sociales</h5>
            <ul class="social-buttons">
              <li>
                <a href="#" class="btn btn-icon btn-neutral btn-twitter btn-round">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#" class="btn btn-icon btn-neutral btn-facebook btn-round">
                  <i class="fab fa-facebook-square"></i>
                </a>
              </li>
              <li>
                <a href="#" class="btn btn-icon btn-neutral btn-dribbble btn-round">
                  <i class="fab fa-dribbble"></i>
                </a>
              </li>
              <li>
                <a href="#" class="btn btn-icon btn-neutral btn-google btn-round">
                  <i class="fab fa-google-plus"></i>
                </a>
              </li>
              <li>
                <a href="#" class="btn btn-icon btn-neutral btn-instagram btn-round">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          -->
        </div>
      </div>
      <hr>
      <div class="copyright">
        Copyright &copy;
        {{year}}
        Desarrolado por
        <a href="https:///www.zaiq.co" target="_blank">Zaiq</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
/* .sssalud{
    text-align: center;
} */
</style>
